import { API_TYPE } from "@umu/umu-fetch";
import { IColumn } from "common/src/components/customTable/interface";

export enum BatchImportType {
	binary = "binary",
	object = "object"
}

export interface ILabelProps {
	label1: string;
	label2: string;
	label3: string;
	label4: string;
}

export enum UPLOAD_RESULT {
	NO_START = 1,
	IN_PROGRESS = 2,
	SUCCESS_COMPLETE = 3,
	ERROR_COMPLETE = 4,
}

export interface IData {
	[propName: string]: any;
}

export interface IDataSource {
	[propName: string]: string | string[];
}

export interface IColumnsItem {
	title: string;
	dataIndex: string;
	name?: string | JSX.Element;
	render?: (item: IData) => JSX.Element | number | string | undefined;
}


export interface IUpload {
	resourceId: number;
	url: string;
	fileSize: number;
}

export interface IEncodeResult {
	blob: Blob;
	ext: string;
	fileName: string;
}

export enum SHOW_TYPE {
	DESC_PANEL = 'desc',
	SUCCESS_PANEL = 'success',
	FAIL_PANEL = 'fail',
}

export enum FILE_API_TYPE {
	DOWNLOAD_EXCEL = 'DOWNLOAD_EXCEL',
	UPLOAD = 'UPLOAD',
	PROGRESS = 'PROGRESS',
	EXPORT = 'EXPORT',
	DOWNLOAD_FAILED_RECORDS = 'DOWNLOAD_FAILED_RECORDS',
}

export enum SEARCH_PARAM_KEY {
	STUDENT_NAME = 'mentee_id',
	MENTOR_NAME = 'mentor_id',
}
export interface ISearchParams {
	[SEARCH_PARAM_KEY.STUDENT_NAME]?: string;
	[SEARCH_PARAM_KEY.MENTOR_NAME]?: string;
}

export enum OJT_TYPE {
	MENTOR = '9',
}

export interface IErrParam {
	instance_id?: string;
}

export interface IPageFileDownload {
	is_async: boolean;
	file_url: string;
}

export interface IPageFileDownloadResponse {
	data: IPageFileDownload;
}

export interface IUpLoadFileParam {
	type: OJT_TYPE;
	file_url: string;
}

export interface IProgressParam {
	instance_id: string;
}

export interface IFileProgressParam extends IProgressParam {
	type: string;
}

export interface IProcessFileDownloadOptions {
	apiType: FILE_API_TYPE;
	params: IUpLoadFileParam | IFileProgressParam;
}

export interface IFailedRecordProps {
	data: string[];
}

export interface IUpLoadFileRes {
	status?: number;
	instance_id?: string;
}

export interface IProgressRes {
	status: number;
	total_lines: number;
	processed_lines: number;
	failed_records: IFailedRecordProps[];
}

export type DownloadDataRequestParams = {
	class?: string;
	params?: any;
	type?: number;
	instance_id?: string,
	is_output_sync?: number,
}

export type DownloadDataRequest = {
	api?: {
		url: string;
		type: API_TYPE;
	},
	params?: DownloadDataRequestParams;
}

export type DownloadData = {
	name?: string,
	url?: string,
} & DownloadDataRequest


export type UploadDataRequest = {
	api?: {
		url: string;
		type: API_TYPE;
	},
	params?: {
		page?: number;
		size?: number;
		type?: number;
		excel?: string;
		file_url?: string;
		excel_url?: string;
		instance_id?: string;
		assessment_id?: string;
	}
}

export type UploadData = {
	name?: string;
	type?: BatchImportType;
} & UploadDataRequest;

export enum UploadDataType {
	uploadExcel = "uploadExcel",
	uploadProgress = "uploadProgress",
	uploadErrorRecord = "uploadErrorRecord"
}

export type UploadDataMap = {
	[UploadDataType.uploadExcel]?: UploadData,
	[UploadDataType.uploadProgress]?: UploadData,
	[UploadDataType.uploadErrorRecord]?: UploadData
}

export enum DownloadType {
	errorRecord = "errorRecord",
	exportExcel = "exportExcel",
	importTemplate = "importTemplate",
}

export type DownloadDataMap = {
	[DownloadType.errorRecord]?: DownloadData,
	[DownloadType.exportExcel]?: DownloadData,
	[DownloadType.importTemplate]?: DownloadData
}

export type TableColumns = { [key: number]: Partial<IColumn> };
export type TableColumnsFun = (columns: any[]) => TableColumns
export type TableColumnsMap = TableColumns | TableColumnsFun

export interface BatchImport {
	id?: string;
	userId: string;
	className?: string;
	sizeMessage?: string;
	tableTdWidth?: number;
	limitFileSize?: number;
	isHiddenNotes?: boolean;
	callback?: VoidFunction;
	isMultilevel?: boolean;
	customNotes?: JSX.Element;
	uploadDataMap: UploadDataMap;
	isHiddenTableTitle?: boolean;
	limitShowFailedCount?: number;
	downloadDataMap: DownloadDataMap;
	tableColumnsMap?: TableColumnsMap;
	uploadIntroduction: {
		data: IData[];
		label: ILabelProps;
		columns: IColumn[];
	},
	uploadFailed?: {
		columns?: IColumn[];
	},
	customFailMsg?: (totalNumber: number, failedNumber?: number) => JSX.Element;
	customSuccessMsg?: (totalNumber: number, failedNumber?: number) => JSX.Element;
}

export type BinaryUploadReaponseData = {
	message: string;
	status: number;
}

export type BinaryUploadResponse = {
	error_code: number;
	error_message: string;
	data: BinaryUploadReaponseData
}

export type BinaryProgressData = {
	failed: number,
	success: number,
	total: number
}

export type DownloadExcelFileResponseData = {
	is_async?: boolean;
	file_url?: string;
	status?: number;
	download_url?: string;
}

export type DownloadExcelFileResponse = {
	data: DownloadExcelFileResponseData
}

interface IPanelColumnsItem extends IColumnsItem {
	errHide?: boolean;
}

export interface IFailedRecordColumn {
	[propsName: string]: string;
}

export interface IPageSource {
	columns: IPanelColumnsItem[];
	label: ILabelProps;
	dataSource: IDataSource[];
	moduleFile: string;
}

